import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayTime extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayTime {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: TEDDisplayTime;

  public mode() {
    return TEDParseDateTimeMode.pdmHMS;
  }
}

export { TEDDisplayTime };
